import { EStatusLink } from '@/domain/Availability.domain';
import { TAvailabilityState } from './domain';

export const DEFAULT_AVAILABILITY_STATE: TAvailabilityState = {
    activityId: '',
    partnerSlug: '',
    enableTips: false,
    selectedDate: '',
    months: {},
    loadingMonth: false,
    loadingOvernights: false,
    days: {},
    overnights: {},
    overnightsDurations: {},
    monthAvail: [],
    loadingDay: false,
    selectedSchedule: undefined,
    selectedDayFull: undefined,
    selectedTickets: {},
    ticketNames: {},
    selectedOptions: {},
    gratuity: undefined,
    isCustom: 0,
    comment: '',
    agreementSelected: false,
    termsSelected: undefined,
    status: {
        isValid: false,
        message: 'Please select the ticket type.',
        error: false,
        touched: false,
        link: EStatusLink.TICKETS,
    },
    needTicketsNames: false,
    noSchedules: false,
    noCalendar: false,
    ticketsSum: '',
    optionsSum: 0,
    tipsPrice: 0,
    totalSum: 0,
    overnightsView: false,
    selectedOvernightsDuration: '',
    isTour: false,
};
